export default __webpack_public_path__ + "static/media/show-oil-2.2963b11c.webp";